import Vue from 'vue'
import LineSpecialInput from './LineSpecialInput'
import LineSpecialResult from './LineSpecialResult'

export default {
  install(Vue, options) {
    Vue.component('line-spesial-input', LineSpecialInput)
    Vue.component('line-spesial-result', LineSpecialResult)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/recommend/line_special/line_special.js